import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const aboutContainer = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 32,
  maxWidth: 1440,
  margin: "48px auto",
  padding: "0 16px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    textAlign: "center",
    gap: 16,
  },
});

export const textSection = css({
  flex: 1,
});

export const imageSection = css({
  position: "relative",
  flex: 1,
  aspectRatio: "16/9",
  width: "100%",

  img: {
    objectFit: "cover",
  },
});
